import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import "../styles/Navbar.css";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Scroll to top (same page OR new page)
  const handleNavClick = () => {
    setIsOpen(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Navigate to home + scroll to section
  const handleSectionClick = (id) => {
    setIsOpen(false);

    navigate("/", {
      state: { scrollTo: id },
    });
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        {/* Logo */}
        <Link to="/" className="nav-logo" onClick={handleNavClick}>
          <img className="cropped-image" src="/logo.png" alt="FNBDataLab" />
        </Link>

        {/* Menu */}
        <div className={`nav-menu ${isOpen ? "active" : ""}`}>
          <Link to="/" className="nav-link" onClick={handleNavClick}>
            Home
          </Link>

          <Link to="/about-us" className="nav-link" onClick={handleNavClick}>
            About Us
          </Link>

          <Link to="/our-services" className="nav-link" onClick={handleNavClick}>
            Our Services
          </Link>
          <Link to="/our-work" className="nav-link" onClick={handleNavClick}>
            Our Work
          </Link>
          <Link to="/contact" className="nav-link" onClick={handleNavClick}>
            Contact
          </Link>
          
        {/* <div className="nav-cta-desktop"> */}
        <div className="nav-cta-group">
          <Link to="/operationals-diagnostic" className="nav-cta-btn2">
            Operational Diagnostic
          </Link>
        <Link to="/contact" className="nav-cta-btn">
          Book a Fit Call
        </Link>
        </div>
        {/* </div> */}


        {/* <div className="nav-cta-desktop"> */}
   {/* <Link to="/operationals-diagnostic" className="nav-cta-btn2">
            Operational Diagnostic
          </Link>

  <Link to="/contact" className="nav-cta-btn">
    Book a Fit Call
  </Link> */}
{/* </div> */}
</div>
        
        {/* Mobile toggle */}
        <div className="nav-toggle" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </div>
      </div>
      
      
    </nav>
  );
};

export default Navbar;
